import staticConfig from 'src/config'

const { supportedChains } = staticConfig

export const checkChainSupported = (chainId?: number) =>
  supportedChains.some(chain => chainId === chain.id)

export const getActiveOrDefaultChain = (chainId?: number) =>
  supportedChains.find(chain => chainId === chain.id) ||
  staticConfig.defaultChain

export const getChainByName = (name: string) =>
  supportedChains.find(chain => chain.name === name)
